module.exports = __webpack_public_path__ + "media/shape/shape-56-0874d92b.png";